module.exports = __webpack_public_path__ + "img/banner-princiapal.a549bda3.svg";